import { Component, OnInit, QueryList, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { DataSource } from '@angular/cdk/table';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { APIIPRegisterService } from '../../_services/ip-register/API-ipregister';
import { APIPaymentService } from '../../_services/payment-dues/payment-dues.service';


let now = new Date();

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.css']
})
export class PaymentHistoryComponent implements OnInit {
  PaymentHistoryForm: FormGroup;
  response: any
  dataSource: any;
  PaymentFlag: any;
  dataSubject = new BehaviorSubject<any[]>([]);
  displayedColumns: string[] = ['urn', 'DLTOrder', 'item', 'amount', 'paymentdate','status'];//,'receipt','invoice'

  EntityID: any
  EntityName: any
	pageNo:number=1
	loginFlag: any;
  @ViewChild('paginator') paginator:MatPaginator;




  constructor(private fb: FormBuilder,

    private db: $DBManagerService,
    private $modal: $ModalManagerService,
    private ip: APIIPRegisterService,
	private ps: APIPaymentService,


  ) { }

  ngOnInit() {
    this.PaymentHistoryForm = this.fb.group({
      urn: [''],
      entityID: [''], //To allow from 15 to 19 digits

      entityName: [''],
    }); 

    this.EntityID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
    this.EntityName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME)
    let Flag = this.db.get(Constants.SESSSION_STORAGE, Constants.PAYMENT_FLAG)
    this.PaymentFlag = atob(Flag)
	this.loginFlag = this.db.get(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG);
	if (this.loginFlag) {
    if(this.PaymentFlag == "true"){
      let EntityRefNo= this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN)
      this.PaymentHistoryForm.controls['urn'].setValue(EntityRefNo);
    }
	}
	else{
	  let URN = this.db.get(Constants.SESSSION_STORAGE, Constants.PAYMENTFORURN)
      this.PaymentHistoryForm.controls['urn'].setValue(URN);
	}
    this.PaymentHistoryForm.controls['entityID'].setValue(this.EntityID);

    this.PaymentHistoryForm.controls['entityName'].setValue(this.EntityName);
	this.getPaymentHistoryDetails()
    // this.getListIPAddress();
  }


  get f() { return this.PaymentHistoryForm.controls; }

  async onSubmit() {
    if (this.PaymentHistoryForm.invalid) {
      return;
    }
    else {

      var data = {
        EntityID: this.PaymentHistoryForm.get("entityID").value,
        Entity_Name: this.PaymentHistoryForm.get("entityName").value,
        Created_By: this.PaymentHistoryForm.get("entityID").value
      }
      await this.ip.addNewIP(data)
        .subscribe(r => {
          console.log("response is : ", r)


        })
      // this.getListIPAddress()


    }

  }
   getPaymentHistoryDetails() {

  //  this.ps.getPaymentHistoryInfo(this.EntityID,this.pageNo)
   // this.ps.PaymentHistorySearchInfo(this.EntityID ? this.EntityID : "NA",  "NA" ,this.pageNo ? this.pageNo : "1", "10")
    this.ps.PaymentHistorySearchInfo(this.EntityID ? this.EntityID : "NA", "NA", "1", "10000") 
      .subscribe({
        next: response => {
         // this.dataSubject.next(response.results);
          this.dataSubject.next(response);
          this.dataSource = new MatTableDataSource();

          //this.dataSource = new MatTableDataSource(response.results);
          this.dataSource = new MatTableDataSource(response);
          this.dataSource.paginator = this.paginator;
          // this.dataSource.sort = this.sort;
        }
      });

  }
	Next(){
		this.pageNo =this.pageNo+1
		this.getPaymentHistoryDetails()
	}
	
	Previous(){
		this.pageNo =this.pageNo-1
		this.getPaymentHistoryDetails()
	}
	
	
  downloadPaymentHistoryCSV() {

    var data = {
     
    }
    if (this.EntityID)
      data["EntityID"] = this.EntityID
   

    var fileName;
    const currentdate = formatDate(now, 'medium', 'en-US', '+0530');
    this.ip.exportPaymentHistoryCSV(data).subscribe(r => {
      fileName = currentdate + this.EntityID + '_IP.csv';


      importedSaveAs(r, fileName)
      this.$modal.successModal({
        title: 'Payment History',
        msg: 'File has been downloaded Successfully'
      });
    })

  }



}





